import { useEffect, useState } from "react";
import { Typography, Button, Select, MenuItem } from "@mui/material";
import { tss } from "tss-react";
import { api } from "api/Call";
import ModalWindow from "components/ModalWindow";
import { Folder } from "@mui/icons-material";
import { FoldersActions } from "actions";
import { config } from "config";

const useStyles = tss.create(() => ({
    title: {
        fontSize: 16,
        fontWeight: "bold",
        marginBottom: 20,
    },
    confirmationText: {
        fontSize: 14,
        marginBottom: 20,
    },
    button: {
        minWidth: 20,
        padding: "5px 5px",
        marginLeft: 5,
        width: 75,
        height: 36,
    },
    bottom: {
        position: "absolute",
        top: "calc(100% - 49px)",
        right: 22,
    },
    nextButton: {
        fontWeight: "bold",
    },
    cancelButton: {
        right: 14,
        fontWeight: "bold",
    },
    select: {
        paddingLeft: "0px",
    },
    menuItem: {
        width: "100%",
        color: "#283C50",
        fontSize: 8,
        letterSpacing: "0px",
    },
    menuItemDiv: {
        display: "flex",
        alignItems: "center",
        height: "100%",
    },
    menuItemSpan: {
        display: "inline-block",
        width: "400px",
        whitespace: "nowrap",
        overflow: "hidden !important",
        textOverflow: "ellipsis",
        verticalAlign: "middle",
    },
    folderIcon: {
        marginRight: "10px",
    },
}));

type IProps = {
    open: boolean;
    catalog: any;
    items: any;
    handleClose: (cancelled: boolean) => void;
};

export default function MovePanel(props: IProps) {
    const { classes } = useStyles();
    const { catalog, open, items } = props;
    const projectId = catalog?.project;
    const [toFolderID, setToFolderID] = useState("");
    const [menuItemsTree, setMenuItemsTree] = useState([]);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        if (open) {
            const menuItems: any = [];
            const BuildMenuItemsTree = (rootFolder: any, level: number, parentID?: string, disabledChild?: boolean) => {
                rootFolder?.subfolders?.forEach((subFolder: any) => {
                    if (subFolder.parent.ID === parentID) {
                        const disabled = disabledChild || items.includes(subFolder.ID);
                        menuItems.push({
                            id: subFolder.ID,
                            name: subFolder.name,
                            level: level,
                            disabled: disabled,
                        });
                        BuildMenuItemsTree(subFolder, level + 1, subFolder.ID, disabled);
                    }
                });
            };
            let rootFolder: any = FoldersActions.getCatalog(projectId, true);
            rootFolder = rootFolder.subfolders[0];
            menuItems.push({
                id: rootFolder?.ID,
                name: rootFolder?.name,
                level: 0,
            });

            BuildMenuItemsTree(rootFolder, 1, "0");
            setMenuItemsTree(menuItems);
            setToFolderID(catalog?.file_folder ? catalog?.file_folder : "");
        }
    }, [open, items, projectId, catalog]);

    const handleCancel = () => {
        props.handleClose(false);
    };

    const handleOk = () => {
        sendData(projectId, toFolderID, items);
        props.handleClose(true);
    };

    const handleChange = (event: any) => {
        setToFolderID(event.target.value);
    };

    const handleMenuOpen = (isOpen: boolean) => {
        setMenuOpen(isOpen);
    };

    const sendData = (projectID: string, folderID: string, items: any) => {
        const body = new FormData();
        body.append("operation", "move");
        body.append("folder", folderID);
        body.append("items", items.join(" "));
        api(`${config.api.endpoints["entity"]}?project=${projectID}`, { body: body }).catch((error: any) => {
            console.error("MovePanel sendData catch");
            console.error(error);
        });
    };

    return (
        <ModalWindow handleClose={handleCancel} width={500} height={200} minHeight={"fit-content"} open={open}>
            <Typography className={classes.title}>Move to folder</Typography>
            <Select
                labelId="select-toFolderID"
                id="select-toFolderID"
                value={toFolderID}
                onChange={handleChange}
                onOpen={(evt) => handleMenuOpen(true)}
                onClose={(evt) => handleMenuOpen(false)}
            >
                {menuItemsTree.map((item: any) => {
                    return (
                        <MenuItem value={item.id} key={item.id} disabled={item.disabled}>
                            <div
                                className={classes.menuItemDiv}
                                style={{ paddingLeft: !menuOpen ? 0 : `${item.level * 20}px` }}
                            >
                                <Folder className={classes.folderIcon} />
                                <span className={classes.menuItemSpan}>{item.name}</span>
                            </div>
                        </MenuItem>
                    );
                })}
            </Select>
            <div className={classes.bottom}>
                <Button
                    onClick={(e) => {
                        handleCancel();
                    }}
                    className={[classes.button, classes.cancelButton].join(" ")}
                >
                    Cancel
                </Button>
                <Button
                    onClick={(e) => {
                        handleOk();
                    }}
                    className={[classes.button, classes.nextButton].join(" ")}
                >
                    Move
                </Button>
            </div>
        </ModalWindow>
    );
}
